import ax from '../axios'
import {API_URL} from "../index";
import { ID } from "../../constants";

const STUDENT_URL = API_URL.EDUCATION_MODULE + '/student'

interface AddStudentPayload {
    userId?: number;
    subUserId?: number;
    name: string;
    lastName: string;
    classroomId: number;
    organizationId: number;
    schoolId: number;
}

interface StudentData {
  name: string;
  lastName: string;
}

interface AddMultipleStudentsPayload {
  dataList: StudentData[];
  organizationId: number;
  schoolId: number;
  classroomId: number;
  gradeLevelId: number;
}

const getStudents = (query: string) => {
    return ax.get(`${STUDENT_URL}/?${query}`)
}

const deleteStudent = (studentId: ID) => {
    return ax.delete(`${STUDENT_URL}/${studentId}`)
}

const addStudent = (payload: AddStudentPayload) => {
    return ax.post(STUDENT_URL, payload)
}

const addMultipleStudents = (payload: AddMultipleStudentsPayload) => {
  return ax.post(`${STUDENT_URL}/add-student-ftc`, payload)
}

export {
    getStudents,
    deleteStudent,
    addStudent,
    addMultipleStudents
}
